const AnswerTypeEnum = {
    YES_NO: 'Yes-No',
    TEXT: 'Text',
    MULTIPLE_CHOICE: 'Multiple-Choice'
}

export default AnswerTypeEnum;
